import React, {Component} from 'react';
import {PhoneNumber} from './phoneNumber';
import {Button} from 'semantic-ui-react';

export class PhoneNumberList extends Component {
  handleChange = (e, res) => {
    let phoneNumbers = this.props.phoneNumbers;
    if (res.value) {
      phoneNumbers.splice(res.name, 1, res.value);
    } else {
      phoneNumbers.splice(res.name, 1);
    }
    this.props.handlePhoneOnBlur();
    this.props.handleChange(e, {name: 'phoneNumbers', value: phoneNumbers});
  };

  addEmptyNumber = (e) => {
    e.preventDefault();
    const num = Math.floor(Math.random() * 10000 + 0).toString();
    const emptyNumber = {
      id: num,
      phoneExtension: '',
    };
    this.handleChange(e, {
      name: this.props.phoneNumbers.length,
      value: emptyNumber,
    });
  };

  render() {
    return (
      <React.Fragment>
        {this.props.phoneNumbers &&
          this.props.phoneNumbers.map((number, index) => {
            return (
              <PhoneNumber
                key={number.id}
                index={index}
                number={number}
                handleChange={this.handleChange}
              />
            );
          })}
        <Button
          key="addPhoneNumber"
          primary
          basic
          content="Add a phone number"
          title="Add a phone number"
          name="addPhoneNumber"
          onClick={this.addEmptyNumber}
        />
      </React.Fragment>
    );
  }
}

export default PhoneNumberList;
